module.exports = __webpack_public_path__ + "493b029900005c45ea63ee697c5f22bf.svg";